import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-interface',
  templateUrl: './icon-interface.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconInterfaceComponent {}
